import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getImage } from 'hooks/get-image';
import cn from 'classnames';
import { available, unavailable, pending } from 'config/asset';
import { Icon } from '@iconify/react';

const AssetCard = ({ asset, className = '' }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div
      className={cn(
        'bg-[#EEEFF4] pt-6 pb-4 px-5 rounded-lg flex flex-col gap-4 shadow relative',
        className
      )}
      onClick={() => navigate('/asset/details/' + asset.id)}
    >
      {asset.requested &&
        <div className="absolute top-3 right-3">
          <Icon icon="lucide:bell-ring" className="text-dark" />
        </div>
      }
      <div className="w-full h-16 flex items-center justify-center overflow-hidden">
        <img
          alt={asset.id}
          src={getImage(asset.files)}
          className={cn(
            'w-full h-full object-contain',
            {
              'grayscale opacity-50': !available.includes(asset.state) || !asset.enabled
            }
          )}
        />
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-xs font-semibold">
          {asset.name}
        </span>
        {available.includes(asset.state) && asset.enabled &&
          <div className="flex items-center gap-1">
            <div className="h-1.5 w-1.5 rounded-full bg-green-500" />
            <span className="text-xs text-green-500">
              {t('general.available')}
            </span>
          </div>
        }
        {unavailable.includes(asset.state) || !asset.enabled &&
          <div className="flex items-center gap-1">
            <div className="h-1.5 w-1.5 rounded-full bg-red-500" />
            <span className="text-xs text-red-500">
              {t('general.unavailable')}
            </span>
          </div>
        }
        {pending.includes(asset.state) && asset.enabled &&
          <div className="flex items-center gap-1">
            <div className="h-1.5 w-1.5 rounded-full bg-yellow-500" />
            {/* <span className="text-xs text-yellow-500">
              {t('general.pending')}
            </span> */}
            <span className="text-xs text-yellow-500 text-truncate">
              {asset.expiresAt || '--'}
            </span>
          </div>
        }
      </div>
    </div>
  )
}

export default AssetCard;